// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"68b497aa","513":"15492d8b","787":"603a5132"}[chunkId] + ".chunk.js";
};